import React from 'react';
import {
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@material-ui/core';
import { Link } from '@material-ui/icons';
import { Filters } from './../services/Filters';

const _filters = new Filters();

export const LinkItem = (props) => {

  const url = _filters.translate(props.item.url, props.appLanguage);
  const name = _filters.translate(props.item.name, props.appLanguage);

  return (
    <ListItem
      divider
      button
      onClick={(e) => props.onClick(e, url)}
    >
      <ListItemIcon><Link /></ListItemIcon>
      <ListItemText>
        {name}
      </ListItemText>
      {url ? _filters.urlIcon(url) : null}
    </ListItem>
  )
}



// WEBPACK FOOTER //
// ./src/components/LinkItem.js